import { createClient } from 'next-sanity';

import { isNonDisplayField } from './stegaFilter';

const config = {
  projectId: process.env.SANITY_PROJECT_ID,
  dataset: process.env.SANITY_DATASET,
  apiVersion: '2024-03-11',
  useCdn: true,
  token: process.env.SANITY_PREVIEW_API_TOKEN,
};

export default createClient(config);

// Draft-mode fetches embed stega metadata so the Presentation tool's
// visual-editing overlays can map rendered content back to Studio fields.
// Only preview traffic pays the encoding cost; published pages use the
// default client above, which stays stega-free.
export const previewSanityClient = createClient({
  ...config,
  stega: {
    enabled: true,
    studioUrl: '/studio',
    // Fields the app consumes as code (tag names, class keys, CSS values) must
    // not be encoded -- invisible characters make them invalid. See stegaFilter.
    filter: (props) => (isNonDisplayField(props.sourcePath) ? false : props.filterDefault(props)),
  },
});
